export const SET_CARD_DETAILS = "SET_CARD_DETAILS";
export const ADD_NEW_CARD = "ADD_NEW_CARD";
export const ADD_NEW_CARD_END = "ADD_NEW_CARD_END";
export const DEL_CARD_POPUP_CLOSE = "DEL_CARD_POPUP_CLOSE";
export const DEFAULT_POPUP_CLOSE = "DEFAULT_POPUP_CLOSE";

const initialState = {
  disableDelBtn: false,
  disableAddBtnCard: false,
  modalStyle: "endnmodal",
  addNewCard: false,
  addPopupDisable: false,
  countryListAll: [],
  stripe_name: "",
  stripe_email: "",
  stripe_address: "",
  stripe_city: "",
  stripe_state: "",
  stripe_country: "",
  stripe_postal: "",
  saveCustomerBtn: false,
  stripe_country_code: "",
  stripe_customer_config: false,
  customerId: "",
  stripe_customer_id: "",
  savedCardData: [],
  delData: null,
  setDefaultData: null,
  delPopup: false,
  setDefaultPopup: false,
  refetchData: false,

  allProducts: [],
  currentPlan: {},
  currentProduct: {},
  openPlanData: false,

  isLoading: true,
  subsBtnDisable: false,

  paidPlans: [],
  cancelBtnDisable: false,
  selectedSubs: null,
  refetchPartnerStripePlan: false,
  refetchAfterSubs: false,
  partnerPlanId: [],
  finalSubsPlanData: null,
  exchangeRate: 1,
  preferredCurrency: "GBP",
  expiredPlans: [],
};

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case SET_CARD_DETAILS: {
      return { ...state, ...action.payload };
    }
    case ADD_NEW_CARD: {
      return {
        ...state,
        addNewCard: true,
        addPopupDisable: false,
        modalStyle: "initmodal",
      };
    }
    case ADD_NEW_CARD_END: {
      return { ...state, addPopupDisable: true, modalStyle: "endnmodal" };
    }
    case DEL_CARD_POPUP_CLOSE: {
      return { ...state, delPopup: false, delData: null, disableDelBtn: false };
    }
    case DEFAULT_POPUP_CLOSE: {
      return { ...state, setDefaultPopup: false, setDefaultData: null };
    }
    default:
      return state;
  }
};
